<template>
  <div class="container mt-5">
    <div class="card border-secondary mb-5 mt-4 mx-auto shade no-events" @mouseover="toggleCardDarken" @mouseout="toggleCardDarken">
      <router-link to="/event/add"><span></span></router-link>
      <div class="card-body text-center">
        <h5 class="card-title">Add an event</h5>
        <p class="card-text">{{ message }}</p>
        <router-link to="/event/add" class="btn btn-primary ml-auto">Add an event</router-link>
      </div>
      <img class="card-img-bottom no-events" src="../assets/images/no-events-img.png">
    </div>
  </div>
</template>

<script>
import CardMixin from '../mixins/card'

export default {
  mixins: [CardMixin],
  props: {
    upcoming: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    message () {
      const prefix = this.upcoming ? 'You don\'t have any events coming up' : 'You haven\'t added any events yet'
      return prefix + '. ' + 'Start hosting today and get the word of your next event out to the Muvve community.'
    }

  }
}
</script>

<style>
@import "../assets/styles/card.css";
</style>

<style scoped>
.card-deck {
  min-height: 260px;
}
</style>
